import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";

export const HorizontalScrollContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  width: "100%",
  maxWidth: "100%",
  overflowX: "auto",
  overflowY: "hidden",
  alignItems: "stretch",
  "&::-webkit-scrollbar": {
    display: "flex",
  },
  "&::-webkit-scrollbar-track": {
backgroundColor: theme.palette.background.default,  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: `${theme.palette.primary.main}`,
    borderRadius: "100px",
    FaBorderStyle: 'pointed',
    border: `3px solid ${theme.palette.secondary.main}`,
  },
}));

export const TimelineSlice = styled(Box)(({ theme }) => ({
  minWidth: "400px", // Forces scrolling if screen is too small
  position: "relative",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  background: `linear-gradient(${theme.palette.background.default}, ${theme.palette.primary.main})`,
}));


export const StyledImage = styled("img")<{ opacity: number }>(({ opacity }) => ({
  maxWidth: "300px",
  height: "225px",
  borderRadius: "50px",
  opacity: opacity,
  transition: "opacity 0.3s ease, transform 0.3s ease",
  cursor: "pointer",
  boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
  "&:hover": {
    transform: "scale(1.02)",
  },
}));

export const baseBlockStyles = {
  display: "flex",
  flexDirection: "column",
  p: 2,
} as const;

export const dateBoxStyles = {
  p: 1,
  borderRadius: 2,
  mb: 1,
  textAlign: "center",
} as const;